// 2026-05-06 — staging env for the dev server deploy
// (dev-admin.murtel.org). Backend at dev-api.murtel.org proxies to
// the dev box's local port 7272. The angular.json `staging` build
// configuration file-replaces environment.ts with this file.
//
// Selected via `npx ng build --configuration=staging`.

export const environment = {
  production: false,
  meetApiHost: "https://dev-api.murtel.org/",
  meetingHost: "https://dev-api.murtel.org/",
  SERVER_PUBLIC_KEY:
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAq2AMIcZyOPUJE0qElN1xe1GWFuIzFMDCMsAvuvpQJx2UZDaV3FPF1HMcLSjR9rPHB7F/t4fT9UdSOL+D57c0RVJ0u58arUOxGNnoHDlGp46geJYyYKrNVaDh9U3dZ6IU3a4+qI7H0rqstu6/eyRZnaZDcivOJE5eqi5qhfK6G9gFR25dPw2lp/H41pnWiqEjo68clSoSosZiZPNFa8qowNrhoZJF5/SjVDUMcrwvzkCIwiLhr18N+SEZwn6fke/+rqUkW5FDFED/3Zl12FuJ7Rh8oU8X8s46qHBDr79ogSRaDwucVsOWea9aHUw6s4X9zIypVq2aHlXeafv4XJP48wIDAQAB",
  API_KEY: "3h@jNmC$684nnBujZ!fgHyEwb8Q2@V",
  AES_KEY: "5v8y/B?E(H+MbQeThWmYq3t6w9z$C&F)",
  IV_LENGTH: 16,
  ENC_MODE: "aes-256-cbc",
  ENC_TYPE: "hex",
  version: "1.0",
  ForceAdminOtpLogin: true,
  // Same Firebase project as dev (maqare-beta) so push notifications
  // and OTP test mode (fixed code 12345) work as on local dev.
  firebase: {
    apiKey: "AIzaSyDMoe4NmN3xRu4HcFFsCb2sUBbk5pzOc4Y",
    authDomain: "maqare-beta.firebaseapp.com",
    projectId: "maqare-beta",
    storageBucket: "maqare-beta.firebasestorage.app",
    messagingSenderId: "710363539974",
    appId: "1:710363539974:web:407a78564b9950dc8d7187",
    measurementId: "G-L3YML8MXFT",
    vapidKey: "BE4tFtd0dRoFRrYlRNs672-wA1N-niN-PCidWbNpui1BJdtFAyp94Yqgv_ClOoN9cY9Vxm-7wfoCIH8ImmPnjvs",
  },
};
